import React from "react";

export default function UserManagement() {
    return (
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M13.5028 13.5209C15.5764 13.5209 17.2633 11.834 17.2633 9.76044C17.2633 7.68692 15.5764 6 13.5028 6C11.4242 6 9.7373 7.68692 9.7373 9.76044C9.7373 11.834 11.4242 13.5209 13.5028 13.5209Z"
                fill="#4F6E90"/>
            <path
                d="M19.6864 15.7772C19.5872 15.1713 19.326 14.5968 18.9239 14.1268C18.5322 13.6619 18.0099 13.3121 17.4145 13.1136C17.29 13.0723 17.1625 13.0422 17.0368 13.005C16.158 13.9615 14.901 14.5659 13.5025 14.5659C12.102 14.5659 10.8433 13.9613 9.96347 13.0037C9.83597 13.0414 9.70667 13.0718 9.58044 13.1138C8.38445 13.5109 7.51736 14.5343 7.31387 15.7774L7.03693 17.4695C6.79161 18.9684 7.79435 20.4047 9.27745 20.6762C10.6772 20.932 12.0872 21.0626 13.5025 21.0626C14.9128 21.0626 16.3227 20.932 17.7225 20.6762C19.2057 20.4046 20.2086 18.9684 19.963 17.4695L19.6864 15.7772Z"
                fill="#354F6C"/>
        </svg>
    );
}
